<div class="px-3 pt-3">
  <app-inline-filter-card (onApply)="filterCardData$.next($event)"></app-inline-filter-card>
  <mat-card>
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="store.data$()"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        [customColumnDef]="[
          { name: 'name', template: isNameCell, isSortable: true },
          { name: 'isActive', template: isActiveCell, isSortable: true },
        ]"
        (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
        (editClick)="initializeEdit()"
        (addClick)="initializeAdd()"
        (duplicateClick)="duplicateWorkInstruction()"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
      />
    </mat-card-content>
  </mat-card>
</div>
<ng-template #isNameCell let-row="row">
  <div class="link-button d-flex align-items-center" (click)="openWorkInstructionEditor(row.id, row.name)">
    <mat-icon class="v-middle pe-1">menu_book</mat-icon>
    <span>{{ row.name }}</span>
  </div>
</ng-template>

<ng-template #isActiveCell let-row="row">
  <mat-chip [ngClass]="row.isActive ? 'green' : 'red'" selectable="false">
    {{ (row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase }}
  </mat-chip>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <mat-form-field class="pb-075" appearance="outline">
          <mat-label>{{ 'field.totalProcessCycleTime' | translate }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="00:00:00"
            formControlName="totalProcessCycleTime"
            pattern="^\d{1,4}:[0-5]\d:[0-5]\d$"
          />
          <mat-hint>{{ 'workInstruction.timeToCompleteHint' | translate }}</mat-hint>
          <mat-error [control]="addEditForm.get('totalProcessCycleTime')"></mat-error>
        </mat-form-field>
        <div class="bulk-dialog-field">
          <mat-checkbox
            *ngIf="isBulkEdit()"
            (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isActive'))"
          >
          </mat-checkbox>
          <mat-checkbox formControlName="isActive">
            {{ 'field.active' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #workInstructionEditorDialog>
  <h1 mat-dialog-title *ngIf="selectedWorkInstruction">
    {{ selectedWorkInstruction.name }}
  </h1>
  <app-work-instruction-editor
    *ngIf="selectedWorkInstruction"
    [selectedWorkInstruction]="selectedWorkInstruction"
    (editedFormOfSteps)="getEditedForms($event)"
  ></app-work-instruction-editor>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit" (click)="onSubmit()">{{ 'button.saveChanges' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
